import { getCurrentRef } from '@vista-digital/react-tools';
/**
 * Returns the supplied point in page coordinates as a point relative to the bounding rect of the supplied element.
 */
export function getElementRelativePoint(elementRef, pagePoint) {
    const elementRect = getCurrentRef(elementRef).getBoundingClientRect();
    return { x: pagePoint.x - elementRect.left, y: pagePoint.y - elementRect.top };
}
//# sourceMappingURL=get-element-relative-point.js.map